/// fetch account data and related data from sources

import { browser } from '$app/environment';
import { Auth } from 'aws-amplify';
import { get } from 'svelte/store';
import { useAccount } from './account';
import { getClientByAccount } from '$lib/client/get-client-by-account';

/** fetch current account data as well as related datas from sources
 * - cognitor: main account control
 * - data: client data
 */
export const getCurrentAccount = async () => {
	if (!browser) return;

	const { account } = useAccount();

	await Auth.currentAuthenticatedUser()
		.then((user) => account.set(user))
		.catch(() => account.set(null));

	// fetch client data of current auth
	getClientByAccount(false, get(account));

	return get(account);
};
